/** Query Key Factory — domínio Operações */

export const postitKeys = {
  all: ["postits"] as const,
  lists: () => [...postitKeys.all, "list"] as const,
  list: (params?: { scope?: string }) =>
    [...postitKeys.lists(), { params }] as const,
  detail: (id: string) => [...postitKeys.all, id] as const,
};

export const projectKeys = {
  all: ["projects"] as const,
  lists: () => [...projectKeys.all, "list"] as const,
  list: (params?: Record<string, unknown>) =>
    [...projectKeys.lists(), { params }] as const,
  details: () => [...projectKeys.all, "detail"] as const,
  detail: (id: string | null | undefined) =>
    [...projectKeys.details(), id] as const,
};
